/* eslint-disable no-unused-vars */
/* eslint-disable space-before-function-paren */
/*
 * @Author: MWeiLiu
 * @Date: 2019-12-17 20:19:17
 * @Last Modified by: MWeiLiu
 * @Last Modified time: 2019-12-17 20:44:14
 */
import { Message } from 'element-ui'
import Common from './common.js'
const axios = require('axios')
const QS = require('QS')
const api = require('./api.js')
const env = process.env

// 设置超时时间
axios.defaults.timeout = 10000
// post请求头
axios.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded;charset=UTF-8'

function get(url, params) {
  var token = localStorage.getItem('token')
  params.token = token
  return new Promise((resolve, reject) => {
    axios
      .get(url, params)
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}

function post(url, params) {
  var token = localStorage.getItem('token')
  params.token = token
  return new Promise((resolve, reject) => {
    axios
      .post(url, QS.stringify(params))
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}

function upfilepost(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params, {
        processData: false,
        traditional: true,
        contentType: false,
        headers: {
          'Content-Type': false
        }
      })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 请求拦截器
axios.interceptors.request.use(
  confirm => {
    return confirm
  },
  error => {
    return Promise.error(error)
  }
)

// 响应拦截器
axios.interceptors.response.use(
  response => {
    if (response.status === 200) {
      if (response.data.code === '4001') {
        localStorage.removeItem('token')
        Message({
          message: response.data.msg,
          type: 'warning'
        })
        location.reload()
      }
      if (
        response.data &&
        response.data.data &&
        typeof response.data.data === 'object' &&
        response.data.data.length > 0
      ) {
        response.data.data.map(async item => {
          // eslint-disable-next-line camelcase
          if (item.cover_img) {
            item.cover_img = await Common.imgIsOnload(item.cover_img)
          }
          if (item.link_image) {
            item.link_image = await Common.imgIsOnload(item.link_image)
          }
        })
      }
      return Promise.resolve(response)
    } else {
      return Promise.reject(response)
    }
  },
  error => {
    return Promise.reject(error.response)
  }
)

export function request({ method, url, params }) {
  if (method === 'GET') {
    return get(`${env.REQUERT_URL}${api[url]}`, params || {})
  } else if (method === 'POST') {
    return post(`${env.REQUERT_URL}${api[url]}`, params || {})
  }
}

export function upfile({ url, params }) {
  return upfilepost(`${env.REQUERT_URL}${api[url]}`, params)
}

export function error(err, option) {
  console.log(err)
  option.that.$notify.error({
    title: '错误',
    message: '网络不给力，请重试！'
  })
}



// WEBPACK FOOTER //
// ./src/assets/js/request.js